import { useAudienceVisitorsTableMapState } from "./AudienceVisitorsTableMapState";
import { FilterByProduct as SharedFilterByProduct } from "@/migrated-widgets/table-map/components/shared/FilterByProduct";

export const FilterByProduct: React.FC<{}> = () => {
  const { products, setProducts, distinctProducts } = useAudienceVisitorsTableMapState();

  return (
    <SharedFilterByProduct
      products={products}
      setProducts={setProducts}
      distinctProducts={distinctProducts}
    />
  )
}
